export default "__VITE_ASSET__C9QHPAh4__"